import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { clientErrorTracker, trans } from '@spotahome/soyuz/client';

import { useEcommerceManagerFactory } from '@spotahome/ecommerce-tracking';

import Homecard from '@spotahome/marketplace-common/src/components/Homecard';
import { ListingShape } from '@spotahome/marketplace-common/src/shapes/listing';

import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import { ListingSectionObservable } from '../ListingSection';
import HomecardScrollList from '../ListingsAround/HomecardScrollList';

import './OtherRoomsSection.scss';

const OtherRoomsSection = ({
  otherRooms,
  mainListing,
  locale = '',
  isLogged = false
}) => {
  const ecommerceManager = useEcommerceManagerFactory();

  useEffect(() => {
    try {
      ecommerceManager.trackExtraRoomsImpressions(otherRooms, mainListing);
    } catch (err) {
      clientErrorTracker.error({
        error: err,
        source: 'OtherRoomsSection-trackExtraRoomsImpressions'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleHomecardClick = (homecard, position) => {
    try {
      ecommerceManager.trackExtraRoomClick(
        homecard,
        mainListing,
        isLogged,
        locale,
        position
      );
    } catch (err) {
      clientErrorTracker.error({
        error: err,
        source: 'OtherRoomsSection-handleHomecardClick'
      });
    }
  };

  return (
    <ListingSectionObservable
      section="otherRooms"
      className="other-rooms-section"
      bordered={false}
    >
      <ListingTitle>{trans('listing.other-rooms.title')}</ListingTitle>
      <HomecardScrollList
        homecards={otherRooms}
        listClassName="other-rooms-section__list"
        renderItem={(data, position, handleItemClick) => (
          <Homecard
            key={data.id}
            position={position}
            data={{ ...data, title: data.cardTitle, city: mainListing.cityId }}
            onClick={() => {
              handleItemClick();
              handleHomecardClick(data, position);
            }}
            hasLazyLoad
            pageType="product_page"
            section="other_rooms"
          />
        )}
      />
    </ListingSectionObservable>
  );
};

OtherRoomsSection.propTypes = {
  otherRooms: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string }))
    .isRequired,
  mainListing: PropTypes.shape(ListingShape).isRequired,
  locale: PropTypes.string,
  isLogged: PropTypes.bool
};

export default OtherRoomsSection;
